import { render, staticRenderFns } from "./defaultMessageSetup.vue?vue&type=template&id=0fd4c169"
import script from "./defaultMessageSetup.vue?vue&type=script&lang=js"
export * from "./defaultMessageSetup.vue?vue&type=script&lang=js"
import style0 from "./defaultMessageSetup.vue?vue&type=style&index=0&id=0fd4c169&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports